// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getCachedPlatformStats } from '../services/platformStatsService';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [platformStats, setPlatformStats] = useState({
    totalStudents: 0,
    totalCompanies: 0,
    totalProjects: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const stats = await getCachedPlatformStats();
        setPlatformStats(stats);
      } catch (error) {
        console.error('Error fetching platform stats:', error);
      }
    };

    fetchStats();
  }, []);

  const handleSectionLink = (sectionId, e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <footer style={{
      backgroundColor: '#1a1a1a',
      color: 'white',
      padding: '30px 0 15px 0',
      marginTop: 'auto',
      width: '100%'
    }}>
      <div className="container">
        {/* Platform Stats Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: '15px',
          paddingBottom: '15px',
          borderBottom: '1px solid #333'
        }}>
          <h3 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '15px',
            color: 'white'
          }}>
            Join Our Growing Community
          </h3>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '60px',
            flexWrap: 'wrap'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                fontSize: '36px',
                fontWeight: 'bold',
                color: '#6366f1',
                marginBottom: '8px'
              }}>
                {platformStats.totalStudents}+
              </div>
              <div style={{
                fontSize: '14px',
                color: '#9ca3af',
                fontWeight: '500'
              }}>
                Active Students
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                fontSize: '36px',
                fontWeight: 'bold',
                color: '#6366f1',
                marginBottom: '8px'
              }}>
                {platformStats.totalProjects}+
              </div>
              <div style={{
                fontSize: '14px',
                color: '#9ca3af',
                fontWeight: '500'
              }}>
                Projects
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                fontSize: '36px',
                fontWeight: 'bold',
                color: '#6366f1',
                marginBottom: '8px'
              }}>
                {platformStats.totalCompanies}+
              </div>
              <div style={{
                fontSize: '14px',
                color: '#9ca3af',
                fontWeight: '500'
              }}>
                Companies
              </div>
            </div>
          </div>
        </div>

        {/* Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
          gap: '30px',
          marginBottom: '15px'
        }}>
          {/* Company Info */}
          <div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#6366f1',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center'
            }}>
              Synked
            </div>
            <p style={{
              color: '#a0aec0',
              lineHeight: '1.6',
              marginBottom: '20px',
              fontSize: '14px'
            }}>
              Connecting talented students with companies for impactful
              project experiences that benefit everyone.
            </p>
            <div style={{
              display: 'flex',
              gap: '12px'
            }}>
              {/* Twitter */}
              <a href="https://x.com/synked03" target="_blank" rel="noopener noreferrer" style={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                backgroundColor: '#4a5568',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#1da1f2';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#4a5568';
                e.target.style.transform = 'translateY(0)';
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="https://www.linkedin.com/company/synkline" target="_blank" rel="noopener noreferrer" style={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                backgroundColor: '#4a5568',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#0077b5';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#4a5568';
                e.target.style.transform = 'translateY(0)';
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/synked0/" target="_blank" rel="noopener noreferrer" style={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                backgroundColor: '#4a5568',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#4a5568';
                e.target.style.transform = 'translateY(0)';
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: 'white',
              marginBottom: '20px'
            }}>
              Resources
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <a href="#how-it-works"
                   onClick={(e) => handleSectionLink('how-it-works', e)}
                   style={{
                     color: '#a0aec0',
                     textDecoration: 'none',
                     fontSize: '14px',
                     transition: 'color 0.2s ease'
                   }}
                   onMouseEnter={(e) => e.target.style.color = 'white'}
                   onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  How It Works
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/pricing" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Pricing Plans
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/blog" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Blog
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#testimonials"
                   onClick={(e) => handleSectionLink('testimonials', e)}
                   style={{
                     color: '#a0aec0',
                     textDecoration: 'none',
                     fontSize: '14px',
                     transition: 'color 0.2s ease'
                   }}
                   onMouseEnter={(e) => e.target.style.color = 'white'}
                   onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Success Stories
                </a>
              </li>
            </ul>
          </div>

          {/* For Students */}
          <div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: 'white',
              marginBottom: '20px'
            }}>
              For Students
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/projects" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Browse Projects
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/create-profile" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Create Profile
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/skills-assessment" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Skills Assessment
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/learning-resources" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Learning Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: 'white',
              marginBottom: '20px'
            }}>
              Company
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/about-us" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  About Us
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/careers" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Careers
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/contact-us" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Contact Us
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/support" style={{
                  color: '#a0aec0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#a0aec0'}>
                  Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div style={{
          borderTop: '1px solid #4a5568',
          paddingTop: '20px',
          textAlign: 'center'
        }}>
          <p style={{
            color: '#a0aec0',
            fontSize: '14px',
            margin: 0
          }}>
            © {new Date().getFullYear()} Synked. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;